module.exports = __webpack_public_path__ + "static/media/No_result_found.d3676dde.svg";